import React from 'react';
import { COUNTRY_CODES } from '../../../constants/enums';
import SwedenCampaignView from './views/SwedenCampaignView.jsx';
import NorwayCampaignView from './views/NorwayCampaignView.jsx';
import DenmarkCampaignView from './views/DenmarkCampaignView.jsx';

const CountryCampaignView = ({ country, originalOrderlinesData, filteredOrderlinesData,  campaignPromiseType, campaignType, showDaysGraph, isLoading, orderOrderLines}) => {
  if (isLoading) return null;
  switch (country) {
    case COUNTRY_CODES.NORWAY:
      return <NorwayCampaignView 
        originalOrderlinesData={originalOrderlinesData} 
        filteredOrderlinesData={filteredOrderlinesData}
        campaignPromiseType={campaignPromiseType} 
        campaignType={campaignType} 
        showDaysGraph={showDaysGraph}
        orderOrderLines={orderOrderLines}
        />;
    case COUNTRY_CODES.DENMARK:
      return <DenmarkCampaignView 
        orderlinesData={filteredOrderlinesData} 
        campaignPromiseType={campaignPromiseType} 
        campaignType={campaignType} 
        showDaysGraph={showDaysGraph} />;
    case COUNTRY_CODES.SWEDEN:
    default:
      return <SwedenCampaignView 
        orderlinesData={filteredOrderlinesData} 
        campaignPromiseType={campaignPromiseType} 
        campaignType={campaignType} 
        showDaysGraph={showDaysGraph} />;
  }
};

export default CountryCampaignView;
